import React from 'react';
import Scheduling from './scheduler';
import { connect } from 'react-redux';
import { ADASTRA, base64Decode, NE_ABA, VIP } from '../../actions/utilAction';

function AppointmentScheduler(props) {
  let patientId = props.match.params.id ? base64Decode(props.match.params.id) : null;
  return (
    <Scheduling
      {...props}
      headerTitle='Manage Scheduling'
      patientId={patientId}
      showPatientBannerInfo={patientId ? true : false}
      isDragForAppointments={true}
      pathClientProfile='/client/profile'
      pathNonBillableSoap='/non-billable-soap'
      pathVideoSoap='/video-soap'
      pathSoap='/soap'
      pathSessionBehaviorBlossoms='/session-behaviorblossoms'
      pathSessionEBS='/session-notes-data-collection'
      pathSessionCBG='/session-cbg'
      pathSessionAIP='/session-aip'
      pathSessionNE_ABA='/session-ne-aba'      
      pathSession_BT_BESTABA='/session-bt-bestaba'
      pathSession_BCBA_BESTABA='/session-bcba-bestaba'
      pathSession_PSYCHOLOGICAL_SWAN='/session-psychological-swan'
      pathProgressNote_One='/progress-note-one'
      pathSessionNoteABAOR_RBT='/session-note-rbt-abaor'
      pathSessionNoteABAOR_BCBA='/session-note-bcba-abaor'
      pathSession_PBS='/session-pbs'
      pathSession_AssessmentNote_SOAR='/session-note-assessment-soar'      
      pathSession_DirectTherapyNote_SOAR='/session-note-directtherapy-soar'
      pathSession_BCBASupervisionNote_SOAR='/session-note-bcbasupervision-soar'
      pathSession_FamilyTreatmentNote_SOAR='/session-note-familytreatment-soar'
      pathSession_DiagnosticEvaluation_SOAR='/session-note-diagnosticevaluation-soar'
      pathSession_Hyperion='/session-note-hyperion'
      pathSessionSupervision_HIH='/session-supervision-note-helpinghands'
      pathSessionPsychEval_FUTURES='/session-psycheval-note-futures'
      pathSessionSLPEval_FUTURES='/session-slpeval-note-futures'
      pathSessionEarlyIntervention_EBSPA='/session-notes-early-intervention'
      pathSessionDelawareEI_EBS='/session-notes-delaware-ei-ebs'
      pathSessionIFSP_DevelopmentTime_EBS='/session-notes-ifsp-developmenttime-ebs'
      pathSession_RBT_TFABA='/session-notes-rbt-tfaba'
      pathSession_BCBA_TFABA='/session-notes-bcba-tfaba'
      pathSessionIllinois_Evaluation_EBS='/session-notes-illinois-evaluation-ebs'
      pathSessionIllinois_EBS='/session-notes-illinois-ebs'
      pathSessionNotes_BT_Default='/session-notes-bt-default'
      pathSessionNotes_BCBA_Default='/session-notes-bcba-default'
      pathCustomSessionNotes='/custom-session-notes'
      pathCustomNonBillableSessionNotes='/custom-session-nonbillable-soap'
    />
  );
}

const mapStateToProps = (state) => {
  // Start For Role Permission
  let userActionPermission = [];
  let showAddressTypeDuringAppointmentCreation = true; //Show address type during appointment creation
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETE')[0].permission : false;
  let createSoapPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_CREATESOAP')[0].permission : false;
  let viewSoapPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_VIEWSOAP')[0].permission : false;
  let viewClientSchedulesPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_VIEW_CLIENT_SCHEDULES')[0].permission : false;
  let viewTeamSchedulesPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_VIEW_TEAM_SCHEDULES')[0].permission : false;
  let viewOtherStaffSchedulesPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_VIEW_OTHERSTAFF_SCHEDULES')[0].permission : false;
  let cancelPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_CANCEL_APPOINTMENT')[0].permission : false;
  let unCancelPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_CANCEL_APPOINTMENT')[0].permission : false;
  let approveAppointmentPermission = hasDefaultAccess;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let editAppointmentTimeOnlyPermission = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_EDIT_APPOINTMENT_TIME_ONLY')[0].permission : true;
  let createOnlyOwnSoapPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_CREATEOWNSOAP_ONLY')[0].permission : false;
  let viewOnlyOwnSoapPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_VIEWOWNSOAP_ONLY')[0].permission : false;
  let editAppointmentAfterClaimSubmission = hasDefaultAccess ? false : userActionPermission ? !userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_EDIT_APPOINTMENT_AFTER_CLAIMSUBMISSION')[0].permission : true;
  let disableAppointmentEditing = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_EDIT_APPOINTMENT_DISABLE_EDITING')[0].permission : true;

  let overrideAvailabilityWhenScheduling = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'OVERRIDE_AVAILABILITY_WHEN_SCHEDULING')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'OVERRIDE_AVAILABILITY_WHEN_SCHEDULING')[0].permission : false;
  let overrideClientAvailabilityWhenScheduling = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'OVERRIDE_CLIENT_AVAILABILITY_WHEN_SCHEDULING')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'OVERRIDE_CLIENT_AVAILABILITY_WHEN_SCHEDULING')[0].permission : false;
  let modifySessionTimeAfterClaimSubmission = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'MODIFY_SESSION_DETAILS_AFTER_CLAIM_SUBMISSION')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'MODIFY_SESSION_DETAILS_AFTER_CLAIM_SUBMISSION')[0].permission : false;

  let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';
  let addMultipleStaffWhenCreatingNonBillableSession = true;

  if(agencyName.toUpperCase() === VIP || agencyName.toUpperCase() === 'DEMO') { // || agencyName.toUpperCase() === ADASTRA
      addMultipleStaffWhenCreatingNonBillableSession = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'ADD_MULTIPLE_STAFF_WHEN_CREATING_A_NONBILLABLE_APPOINTMENT')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'ADD_MULTIPLE_STAFF_WHEN_CREATING_A_NONBILLABLE_APPOINTMENT')[0].permission : false;
  }
  // let disableAppointmentEditing = false;
  /* edit mileage if user is neither admin nor modifyAfterRenderPermission */
  //let editAppointmentMileageOnlyAfterRenderPermission = modifyAfterRenderPermission ? false : true;
  //editAppointmentAfterClaimSubmission = modifyAfterRenderPermission || !editAppointmentAfterClaimSubmission ? false : true;
  if(agencyName.toUpperCase() === NE_ABA)
  {
    showAddressTypeDuringAppointmentCreation = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_SHOWADDRESSTYPE_APPOINTMENTCREATION')[0].permission : false;
    //showAddressTypeDuringAppointmentCreation = false;
  }  

   let userClientListPermission
   if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    userClientListPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userClientListPermission ? userClientListPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0].permission : false;
 
  // End For Role Permission

  // console.log(createOnlyOwnSoapPermission, viewOnlyOwnSoapPermission)
  return {
    currentLocationId: state.login.currentLocationId,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
    createSoapPermission: createSoapPermission,
    viewSoapPermission: viewSoapPermission,
    viewClientSchedulesPermission: viewClientSchedulesPermission,
    viewTeamSchedulesPermission: viewTeamSchedulesPermission,
    viewOtherStaffSchedulesPermission: viewOtherStaffSchedulesPermission,
    cancelPermission: cancelPermission,
    unCancelPermission: unCancelPermission,
    approveAppointmentPermission: approveAppointmentPermission,
    modifyAfterRenderPermission: modifyAfterRenderPermission,
    editAppointmentTimeOnlyPermission: editAppointmentTimeOnlyPermission,
   // editAppointmentMileageOnlyAfterRenderPermission: editAppointmentMileageOnlyAfterRenderPermission,
    createOnlyOwnSoapPermission: createOnlyOwnSoapPermission,
    viewOnlyOwnSoapPermission: viewOnlyOwnSoapPermission,
    editAppointmentAfterClaimSubmission: editAppointmentAfterClaimSubmission,
    showAddressTypeDuringAppointmentCreation: showAddressTypeDuringAppointmentCreation,
    disableAppointmentEditing: disableAppointmentEditing,
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    overrideAvailabilityWhenScheduling: overrideAvailabilityWhenScheduling,
    overrideClientAvailabilityWhenScheduling:overrideClientAvailabilityWhenScheduling,
    addMultipleStaffWhenCreatingNonBillableSession: addMultipleStaffWhenCreatingNonBillableSession,
    modifySessionTimeAfterClaimSubmission: modifySessionTimeAfterClaimSubmission,
  };
};

export default connect(mapStateToProps, null)(AppointmentScheduler);



// WEBPACK FOOTER //
// ./src/modules/scheduling/index.js